import Home from './Home.data-manager-affise-verbals.vue'

export default { Home }
